import React from "react";
import { Modal, Form, Input, message } from "antd";
import { IRegisteredUserListResponse } from "../../../types/api/users-manage";
import { useUpdateRegisteredUserPassword } from "../../../hooks/api/user/hooks";

interface UserPasswordModalProps {
  isOpen: boolean;
  onClose: () => void;
  user: IRegisteredUserListResponse | null;
}

const UserPasswordModal: React.FC<UserPasswordModalProps> = ({ isOpen, onClose, user }) => {
  const [form] = Form.useForm();
  const passwordMutation = useUpdateRegisteredUserPassword();

  const handleSubmit = async () => {
    try {
      const values = await form.validateFields();
      if (!user?._id) return;

      passwordMutation.mutate(
        {
          id: user._id,
          password: values.password,
        },
        {
          onSuccess: () => {
            message.success("Password reset successfully");
            form.resetFields();
            onClose();
          },
          onError: (err: any) => {
            message.error(err?.response?.data?.message || err?.message || "Failed to update password");
          },
        },
      );
    } catch (err) {
      // validation error
    }
  };

  return (
    <Modal
      title={`Reset Password for ${user?.firstName || user?.name || user?.email}`}
      open={isOpen}
      onCancel={() => {
        form.resetFields();
        onClose();
      }}
      onOk={handleSubmit}
      confirmLoading={passwordMutation.isPending}
      destroyOnClose
    >
      <Form form={form} layout="vertical" className="mt-4">
        <Form.Item
          name="password"
          label="New Password"
          rules={[
            { required: true, message: "Please enter new password" },
            { min: 6, message: "Password must be at least 6 characters" },
          ]}
        >
          <Input.Password placeholder="Enter new password" />
        </Form.Item>

        <Form.Item
          name="confirmPassword"
          label="Confirm New Password"
          dependencies={["password"]}
          rules={[
            { required: true, message: "Please confirm new password" },
            ({ getFieldValue }) => ({
              validator(_, value) {
                if (!value || getFieldValue("password") === value) {
                  return Promise.resolve();
                }
                return Promise.reject(new Error("The two passwords do not match!"));
              },
            }),
          ]}
        >
          <Input.Password placeholder="Confirm new password" />
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default UserPasswordModal;
